import { PATH_PROJECT_MANAGERS } from "@/constants";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { generatePath } from "react-router-dom";

interface ProjectManagersSubMenuProps {
  projectId: string;
}

const ProjectManagersSubMenuComponent = ({
  projectId,
}: ProjectManagersSubMenuProps) => {
  const { t } = useTranslation();
  return (
    <Link
      to={generatePath(PATH_PROJECT_MANAGERS, { projectId })}
      className="font-medium relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:-events-none data-[disabled]:opacity-50"
    >
      {t("projects.breadcrumb.managers")}
    </Link>
  );
};

export const ProjectManagersSubMenu = memo(ProjectManagersSubMenuComponent);
